import { Button } from "reactstrap";
import { useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";
import { undo, redo } from "../utils/undo-redo";
import { forgivingPress } from "../utils/pointer";
import { isTextInput } from "../utils/utils";
import { useEditorSelector } from "../../hooks/redux";

const UndoRedoControls = () => {
  const dispatch = useDispatch();
  const undoDepth = useEditorSelector((state) => state.undoStack.length);
  const redoDepth = useEditorSelector((state) => state.redoStack.length);

  const dispatchAction = useCallback(
    (action: ReturnType<typeof undo> | ReturnType<typeof redo>) => {
      dispatch(action);
    },
    [dispatch],
  );

  useEffect(() => {
    const onGlobalKeydown = (event: KeyboardEvent) => {
      if ((event.target as Element)?.closest(".modal")) {
        return;
      }
      if (isTextInput(event.target)) {
        return;
      }

      if (event.which === 89 && (event.ctrlKey || event.metaKey)) {
        dispatchAction(undo());
        event.preventDefault();
        event.stopPropagation();
      } else if (event.which === 90 && (event.ctrlKey || event.metaKey)) {
        dispatchAction(event.shiftKey ? redo() : undo());
        event.preventDefault();
        event.stopPropagation();
      }
    };

    document.body.addEventListener("keydown", onGlobalKeydown);
    return () => {
      document.body.removeEventListener("keydown", onGlobalKeydown);
    };
  }, [dispatchAction]);

  return (
    <div className={`button-group`}>
      <Button
        className="icon"
        data-tutorial-id="undo-button"
        disabled={undoDepth === 0}
        {...forgivingPress(() => dispatchAction(undo()))}
      >
        <img src={new URL("../img/icon_undo.png", import.meta.url).href} draggable={false} />
      </Button>
      <Button
        className="icon"
        disabled={redoDepth === 0}
        {...forgivingPress(() => dispatchAction(redo()))}
      >
        <img src={new URL("../img/icon_redo.png", import.meta.url).href} draggable={false} />
      </Button>
    </div>
  );
};

export default UndoRedoControls;
